import React from 'react';

import { FormComponent, ModalComponent, UiComponent } from 'components';
import { IUser } from 'types';

interface Props {
  user: IUser;
  onClose: () => void;
  onSave: (data: IUser) => void;
}

function Edit({ user, onClose, onSave }: Props) {
  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal title="" handleClose={onClose} footer={<></>}>
          <FormComponent.Form
            css={{
              display: 'flex',
              flexDirection: 'column',
              width: '500px',
              maxWidth: '100%',
              gap: '12px 0',
            }}
            submit={onSave}
          >
            <p>VMS</p>
            <FormComponent.Input name="vms" defaultValue={user.vms} />
            <p>1365</p>
            <FormComponent.Input name="id1365" defaultValue={user.id1365} />
            {/* <p>인스타</p>
            <FormComponent.Input
              name="instagram"
              defaultValue={user.instagram}
            /> */}

            <UiComponent.Button
              type="submit"
              color="primary"
              variant="contained"
              css={{ width: '120px', margin: '0 auto' }}
            >
              저장
            </UiComponent.Button>
          </FormComponent.Form>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default Edit;
